import React from "react";

export default function KESUSDAd({ onCta, RightVisual }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
            {/* Left copy */}
            <div className="md:col-span-7">
                <h3 className="text-[18px] leading-tight font-[450] text-[#161827]">
                    USD & KES wallets are live
                </h3>

                <p className="text-[14px] text-[#6F739B] font-[350] xl:max-w-[560px] xl:pr-10">
                    Receive, store, and send US dollars and Kenyan shillings directly from your
                    wallet, anytime, anywhere in the world.
                </p>

                <button
                    onClick={onCta}
                    className="mt-4 inline-flex items-center gap-2 rounded-[8px] border border-[#F2F3FC]
                     shadow-[0_0_3px_rgba(146,149,180,0.25)] hover:bg-[#F8F9FB]
                     !px-5 py-2 text-[14px] font-[450] text-[#383B56]"
                >
                    Try it now
                    <svg viewBox="0 0 24 24" className="h-4 w-4">
                        <path
                            d="M5 12h14M13 5l7 7-7 7"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                        />
                    </svg>
                </button>
            </div>

            {/* Right visual */}
            <div className="md:col-span-5">{RightVisual ? <RightVisual /> : null}</div>
        </div>
    );
}
